import {ChangeDetectionStrategy, Component, ViewChild} from '@angular/core';
import {ContextMenuService} from '@shared/directives/context-menu/context-menu.service';
import {ActionMenu, ElPosition, IContextMenu} from '@core/models/common';


@Component({
    selector: 'app-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ContextMenuComponent {

    @ViewChild('listMenu') viewMenu: HTMLElement;
    @ViewChild('menuContainer') menuContainer: HTMLElement;
    option: any;
    position: ElPosition = 'left';
    list: ActionMenu<unknown>[];
    private firstInit: boolean;

    constructor(protected menuService: ContextMenuService) {
    }

    set options(data: IContextMenu<ActionMenu<unknown>>) {
        if (data) {
            this.option = data.option;
            this.position = data.position;
            this.list = data.list;
        }
    }

    onClickedOutside(): void {
        if (this.firstInit) {
            this.menuService.destroy();
        } else {
            this.firstInit = true;
        }
    }

    hide(): void {
        this.menuService.destroy();
    }

    disabled(act: ActionMenu<unknown>): boolean {
        if (!act.disabled) {
            return false;
        }
        if (typeof act.disabled === 'boolean') {
            return act.disabled;
        } else {
            return act.disabled(act.data);
        }

    }

    tooltipTrigger(act: ActionMenu<unknown>): string {
        return act.toolTipIfDisabled && this.disabled(act) && act.toolTip
        || act.toolTip && !act.toolTipIfDisabled ? 'hover' : 'noop';
    }

    action(act: ActionMenu<any>) {
        if (!this.disabled(act)) {
            if (act.action) {
                act.action(act.data);
            } else {
                this.menuService.actionItem.next({event: act.event || act.title || 'default', data: act.data});
            }
            this.hide();
        }
    }


}
